// extracted by mini-css-extract-plugin
export default {"textarea":"styles_textarea__U3-xf","placeholder":"styles_placeholder__Uud85"};